



























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { getTrackingConnections } from '@/api/api';
import moment from 'moment';

interface UserGroup {
  userId: number;
  userName: string;
  email: string;
  mobile: string;
  roles: string[];
  lastLogin: string;
  companyName: string;
  companyImage: string;
  subscriptions: any[];
  allSessions: any[];
  sessionsByDay: any[];
  totalSessions: number;
  totalDuration: number;
  last7DaysSessions: number;
  last7DaysDuration: number;
  last30DaysSessions: number;
  last30DaysDuration: number;
}

interface Stats {
  totalPrescribers: number;
  totalSessions: number;
  avgSessionsPerUser: number;
  last7DaysSessions: number;
  last30DaysSessions: number;
  avgSessionsPerUserPerDay: number;
  usersWithSessionsToday: number;
}

@Component({})
export default class TrackingConnections extends Vue {
  users: UserGroup[] = [];
  filteredUsers: UserGroup[] = [];
  displayedUsers: UserGroup[] = [];
  stats: Stats = {
    totalPrescribers: 0,
    totalSessions: 0,
    avgSessionsPerUser: 0,
    last7DaysSessions: 0,
    last30DaysSessions: 0,
    avgSessionsPerUserPerDay: 0,
    usersWithSessionsToday: 0
  };
  searchQuery: string = '';
  showAdmins: boolean = false;
  expandedSessions: number[] = [];
  expandedSubscriptions: number[] = [];
  expandedDays: { [key: string]: string[] } = {};
  loading: boolean = false;

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const response = await getTrackingConnections();
      const data = response && response.data ? response.data : response;
      
      if (data && data.data) {
        this.users = data.data;
        this.stats = data.stats || this.stats;
      } else if (Array.isArray(data)) {
        this.users = data;
      }
      
      this.filteredUsers = this.users;
      this.filterUsersByRole();
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      this.loading = false;
    }
  }

  filterUsers() {
    if (!this.searchQuery.trim()) {
      this.filteredUsers = this.users;
    } else {
      const query = this.searchQuery.toLowerCase();
      this.filteredUsers = this.users.filter(user => 
        user.userName.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query)
      );
    }
    this.filterUsersByRole();
  }

  filterUsersByRole() {
    if (this.showAdmins) {
      // Show all users (prescribers + admins)
      this.displayedUsers = this.filteredUsers;
    } else {
      // Show only prescribers
      this.displayedUsers = this.filteredUsers.filter(user => {
        const roles = user.roles || [];
        return roles.includes('ROLE_PRESCRIBER') && !roles.includes('ROLE_ADMIN');
      });
    }
  }

  clearSearch() {
    this.searchQuery = '';
    this.filterUsers();
  }

  toggleSessions(userId: number) {
    const index = this.expandedSessions.indexOf(userId);
    if (index > -1) {
      this.expandedSessions.splice(index, 1);
    } else {
      this.expandedSessions.push(userId);
    }
  }

  toggleSubscriptions(userId: number) {
    const index = this.expandedSubscriptions.indexOf(userId);
    if (index > -1) {
      this.expandedSubscriptions.splice(index, 1);
    } else {
      this.expandedSubscriptions.push(userId);
    }
  }

  toggleDaySessions(userId: number, date: string) {
    const key = `${userId}`;
    if (!this.expandedDays[key]) {
      this.expandedDays[key] = [];
    }
    
    const index = this.expandedDays[key].indexOf(date);
    if (index > -1) {
      this.expandedDays[key].splice(index, 1);
    } else {
      this.expandedDays[key].push(date);
    }
    
    this.$forceUpdate();
  }

  isExpanded(userId: number): boolean {
    return this.expandedSessions.includes(userId);
  }

  isSubscriptionExpanded(userId: number): boolean {
    return this.expandedSubscriptions.includes(userId);
  }

  isDayExpanded(userId: number, date: string): boolean {
    const key = `${userId}`;
    return this.expandedDays[key] && this.expandedDays[key].includes(date);
  }

  getRoleClass(roles: string[]): string {
    if (roles && roles.includes('ROLE_ADMIN')) return 'admin';
    if (roles && roles.includes('ROLE_PRESCRIBER')) return 'prescriber';
    return 'default';
  }

  getRoleIcon(roles: string[]): string {
    if (roles && roles.includes('ROLE_ADMIN')) return 'fa-user-shield';
    if (roles && roles.includes('ROLE_PRESCRIBER')) return 'fa-user-tie';
    return 'fa-user';
  }

  getRoleLabel(roles: string[]): string {
    if (roles && roles.includes('ROLE_ADMIN')) return 'Admin';
    if (roles && roles.includes('ROLE_PRESCRIBER')) return 'Prescripteur';
    return 'Utilisateur';
  }

  formatTime(dateTime: string): string {
    return dateTime ? moment(dateTime).format('HH:mm:ss') : '-';
  }

  formatLastSessionDate(dateTime: string): string {
    return dateTime ? moment(dateTime).format('DD/MM/YYYY') : '-';
  }

  formatLastLogin(dateTime: string): string {
    return dateTime ? moment(dateTime).format('DD/MM/YYYY HH:mm') : 'Jamais';
  }

  formatDuration(seconds: number): string {
    if (!seconds || seconds <= 0) return '-';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0) return `${h}h ${m}m ${s}s`;
    if (m > 0) return `${m}m ${s}s`;
    return `${s}s`;
  }

      exportToCSV() {
        try {
          const now = moment().format('YYYY-MM-DD_HH-mm');
          const csvData = [];
          
          // ============================================
          // SECTION 1: RAPPORT DE SYNTHÈSE GÉNÉRALE
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║          RAPPORT DE SUIVI DES CONNEXIONS - SYNTHÈSE          ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);
          csvData.push(['']);
          csvData.push(['Date de génération:', moment().format('DD/MM/YYYY à HH:mm:ss')]);
          csvData.push(['Période d\'analyse:', 'Toutes les données disponibles']);
          csvData.push(['']);
          
          // Statistiques globales dans un format tableau
          csvData.push(['┌─────────────────────────────────────────────┬──────────────────┐']);
          csvData.push(['│ INDICATEUR                                  │ VALEUR           │']);
          csvData.push(['├─────────────────────────────────────────────┼──────────────────┤']);
          csvData.push(['│ Total Prescripteurs                         │', this.stats.totalPrescribers || 0, '│']);
          csvData.push(['│ Total Connexions (toutes périodes)          │', this.stats.totalSessions || 0, '│']);
          csvData.push(['│ Connexions - 7 derniers jours               │', this.stats.last7DaysSessions || 0, '│']);
          csvData.push(['│ Connexions - 30 derniers jours              │', this.stats.last30DaysSessions || 0, '│']);
          csvData.push(['│ Moyenne connexions par utilisateur          │', this.stats.avgSessionsPerUser || 0, '│']);
          csvData.push(['│ Moyenne connexions par jour actif           │', this.stats.avgSessionsPerUserPerDay || 0, '│']);
          csvData.push(['│ Utilisateurs actifs aujourd\'hui             │', this.stats.usersWithSessionsToday || 0, '│']);
          csvData.push(['└─────────────────────────────────────────────┴──────────────────┘']);
          csvData.push(['']);
          csvData.push(['']);
          
          // ============================================
          // SECTION 2: TABLEAU RÉCAPITULATIF PAR UTILISATEUR
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║              RÉCAPITULATIF PAR UTILISATEUR                    ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);
          csvData.push(['']);
          
          // En-têtes avec séparateurs visuels
          csvData.push([
            '┌──────┬────────────────────────┬──────────────────────────────┬────────────────────┬──────────────┬─────────────────┬──────────────────┬──────────────────┬──────────────────┬──────────────────┬──────────────────┬──────────────────┬────────────────────────┐'
          ]);
          csvData.push([
            '│ #    │ Utilisateur            │ Email                        │ Entreprise         │ Rôle         │ Total Connexions│ Durée Totale     │ 7J - Connexions  │ 7J - Durée       │ 30J - Connexions │ 30J - Durée      │ Dernière Connexion│ Statut Abonnement      │'
          ]);
          csvData.push([
            '├──────┼────────────────────────┼──────────────────────────────┼────────────────────┼──────────────┼─────────────────┼──────────────────┼──────────────────┼──────────────────┼──────────────────┼──────────────────┼──────────────────┼────────────────────────┤'
          ]);

          // Données utilisateurs
          this.displayedUsers.forEach((user, index) => {
            const lastSession = user.allSessions && user.allSessions.length > 0 ? user.allSessions[0] : null;
            const latestSubscription = user.subscriptions && user.subscriptions.length > 0 ? user.subscriptions[0] : null;
            
            csvData.push([
              '│',
              (index + 1).toString().padEnd(4),
              '│',
              (user.userName || '').substring(0, 22).padEnd(22),
              '│',
              (user.email || '').substring(0, 28).padEnd(28),
              '│',
              (user.companyName || '').substring(0, 18).padEnd(18),
              '│',
              this.getRoleLabel(user.roles).padEnd(12),
              '│',
              (user.totalSessions || 0).toString().padEnd(15),
              '│',
              this.formatDuration(user.totalDuration || 0).padEnd(16),
              '│',
              (user.last7DaysSessions || 0).toString().padEnd(16),
              '│',
              this.formatDuration(user.last7DaysDuration || 0).padEnd(16),
              '│',
              (user.last30DaysSessions || 0).toString().padEnd(16),
              '│',
              this.formatDuration(user.last30DaysDuration || 0).padEnd(16),
              '│',
              (lastSession ? this.formatLastSessionDate(lastSession.start_time) + ' ' + this.formatTime(lastSession.start_time) : '-').padEnd(16),
              '│',
              (latestSubscription ? this.getSubscriptionStatus(latestSubscription) : 'Aucun').padEnd(22),
              '│'
            ]);
          });
          
          csvData.push([
            '└──────┴────────────────────────┴──────────────────────────────┴────────────────────┴──────────────┴─────────────────┴──────────────────┴──────────────────┴──────────────────┴──────────────────┴──────────────────┴──────────────────┴────────────────────────┘'
          ]);
          csvData.push(['']);
          csvData.push(['']);

          // ============================================
          // SECTION 3: DÉTAILS DES ABONNEMENTS
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║                DÉTAILS DES ABONNEMENTS                        ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);
          csvData.push(['']);
          
          csvData.push([
            '┌────────────────────────┬────────────────┬────────────────┬──────────────┬────────────────┬──────────┬──────────┬──────────────┐'
          ]);
          csvData.push([
            '│ Utilisateur            │ Début          │ Fin            │ Statut       │ Commission     │ JC       │ Honoraires│ Type         │'
          ]);
          csvData.push([
            '├────────────────────────┼────────────────┼────────────────┼──────────────┼────────────────┼──────────┼──────────┼──────────────┤'
          ]);

          this.displayedUsers.forEach(user => {
            if (user.subscriptions && user.subscriptions.length > 0) {
              user.subscriptions.forEach(sub => {
                csvData.push([
                  '│',
                  (user.userName || '').substring(0, 22).padEnd(22),
                  '│',
                  (sub.start_at ? moment(sub.start_at).format('DD/MM/YYYY') : '-').padEnd(14),
                  '│',
                  (sub.end_at ? moment(sub.end_at).format('DD/MM/YYYY') : 'En cours').padEnd(14),
                  '│',
                  this.getSubscriptionStatus(sub).padEnd(12),
                  '│',
                  ((sub.commission_rate * 100) + '%').padEnd(14),
                  '│',
                  (sub.is_jc ? 'Oui' : 'Non').padEnd(8),
                  '│',
                  (sub.with_hono ? 'Oui' : 'Non').padEnd(8),
                  '│',
                  (sub.end_at && moment(sub.end_at).isAfter(moment()) ? 'Actif' : 'Historique').padEnd(12),
                  '│'
                ]);
              });
            }
          });
          
          csvData.push([
            '└────────────────────────┴────────────────┴────────────────┴──────────────┴────────────────┴──────────┴──────────┴──────────────┘'
          ]);
          csvData.push(['']);
          csvData.push(['']);

          // ============================================
          // SECTION 4: HISTORIQUE DÉTAILLÉ DES SESSIONS
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║            HISTORIQUE DÉTAILLÉ DES SESSIONS                   ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);
          csvData.push(['']);
          
          csvData.push([
            '┌────────────────────────┬──────────────┬──────────────┬──────────────┬──────────────┬──────────────────────┬──────────────┐'
          ]);
          csvData.push([
            '│ Utilisateur            │ Date         │ Heure Début  │ Heure Fin    │ Durée        │ Adresse IP           │ Tab ID       │'
          ]);
          csvData.push([
            '├────────────────────────┼──────────────┼──────────────┼──────────────┼──────────────┼──────────────────────┼──────────────┤'
          ]);

          this.displayedUsers.forEach(user => {
            if (user.allSessions && user.allSessions.length > 0) {
              user.allSessions.forEach(session => {
                csvData.push([
                  '│',
                  (user.userName || '').substring(0, 22).padEnd(22),
                  '│',
                  (session.start_time ? moment(session.start_time).format('DD/MM/YYYY') : '-').padEnd(12),
                  '│',
                  (session.start_time ? moment(session.start_time).format('HH:mm:ss') : '-').padEnd(12),
                  '│',
                  (session.end_time ? moment(session.end_time).format('HH:mm:ss') : '-').padEnd(12),
                  '│',
                  this.formatDuration(session.duration || 0).padEnd(12),
                  '│',
                  (session.ip_address || '').substring(0, 20).padEnd(20),
                  '│',
                  (session.tab_id || '').substring(0, 12).padEnd(12),
                  '│'
                ]);
              });
            }
          });
          
          csvData.push([
            '└────────────────────────┴──────────────┴──────────────┴──────────────┴──────────────┴──────────────────────┴──────────────┘'
          ]);
          csvData.push(['']);
          csvData.push(['']);

          // ============================================
          // SECTION 5: SYNTHÈSE PAR JOUR D'ACTIVITÉ
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║              SYNTHÈSE PAR JOUR D\'ACTIVITÉ                     ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);
          csvData.push(['']);
          
          csvData.push([
            '┌────────────────────────┬──────────────────────┬────────────────────┬──────────────────┐'
          ]);
          csvData.push([
            '│ Utilisateur            │ Date                 │ Nb Connexions      │ Durée Totale     │'
          ]);
          csvData.push([
            '├────────────────────────┼──────────────────────┼────────────────────┼──────────────────┤'
          ]);

          this.displayedUsers.forEach(user => {
            if (user.sessionsByDay && user.sessionsByDay.length > 0) {
              user.sessionsByDay.forEach(day => {
                csvData.push([
                  '│',
                  (user.userName || '').substring(0, 22).padEnd(22),
                  '│',
                  (day.formattedDate || '').padEnd(20),
                  '│',
                  (day.nbConnexions || 0).toString().padEnd(18),
                  '│',
                  (day.formattedDuration || '-').padEnd(16),
                  '│'
                ]);
              });
            }
          });
          
          csvData.push([
            '└────────────────────────┴──────────────────────┴────────────────────┴──────────────────┘'
          ]);
          csvData.push(['']);
          csvData.push(['']);

          // ============================================
          // FOOTER
          // ============================================
          csvData.push(['╔════════════════════════════════════════════════════════════════╗']);
          csvData.push(['║                    FIN DU RAPPORT                             ║']);
          csvData.push(['║           Généré automatiquement par le système               ║']);
          csvData.push(['╚════════════════════════════════════════════════════════════════╝']);

          // Conversion en CSV avec gestion des caractères spéciaux
          const csvContent = csvData
            .map(row => row.map(field => {
              const fieldStr = String(field);
              // Échapper les guillemets et encadrer les champs
              return `"${fieldStr.replace(/"/g, '""')}"`;
            }).join(','))
            .join('\n');

          // Création et téléchargement du fichier
          const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          
          link.setAttribute('href', url);
          link.setAttribute('download', `rapport_connexions_detaille_${now}.csv`);
          link.style.visibility = 'hidden';
          
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          console.log('✅ Export CSV détaillé réussi avec', this.displayedUsers.length, 'utilisateurs');
          
        } catch (error) {
          console.error('❌ Erreur lors de l\'export CSV:', error);
          alert('Une erreur est survenue lors de l\'export du fichier CSV. Veuillez réessayer.');
        }
      }



  formatSubscriptionPeriod(sub: any): string {
    if (!sub.start_at) return 'N/A';
    const start = moment(sub.start_at).format('DD/MM/YY');
    const end = sub.end_at ? moment(sub.end_at).format('DD/MM/YY') : 'En cours';
    return `${start} - ${end}`;
  }

  getSubscriptionStatus(sub: any): string {
    if (!sub.end_at) return 'Actif';
    return moment(sub.end_at).isAfter(moment()) ? 'Actif' : 'Expiré';
  }

  getStatusClass(sub: any): string {
    return this.getSubscriptionStatus(sub) === 'Actif' ? 'active' : 'expired';
  }

  getStatusIcon(sub: any): string {
    return this.getSubscriptionStatus(sub) === 'Actif' ? 'fa-check-circle' : 'fa-times-circle';
  }
}
